module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "image-area float-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'single',
        params: {
          language: _vm.language,
          slug: _vm.item.slug
        }
      }
    }
  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
    attrs: {
      "src": _vm.item.acf.image.sizes['grid-large']
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.item.acf.image_en) ? _c('img', {
    attrs: {
      "src": _vm.item.acf.image_en.sizes['grid-large']
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-area float-left"
  }, [_c('div', {
    staticClass: "grid-item"
  }, [_c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.item.tags), function(tag) {
    return _c('dsTagItemInline', {
      attrs: {
        "tag": tag,
        "tags": _vm.tags,
        "language": _vm.language
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "author small-text bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.acf.author))])]), _vm._v(" "), _c('router-link', {
    staticClass: "title roman",
    attrs: {
      "to": {
        name: 'single',
        params: {
          language: _vm.language,
          slug: _vm.item.slug
        }
      }
    }
  }, [(_vm.language === "nl") ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title.rendered)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.title_en)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "description featured-description secondary-color small-text "
  }, [(_vm.language === "nl") ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.excerpt)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.excerpt_en)
    }
  }) : _vm._e()])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f046c80c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsFeaturedItem.vue
// module id = 226
// module chunks = 2